import React from 'react';
import check from "../Resources/svg/check.svg";
import error from "../Resources/svg/error.svg";


function ModalGenerateQuote({ open, dataModal, navigationNext, setOpen, dataModelQuote, uploadRequest, loadingClick }) {
    return (
        <div className={`modalCustom ${open ? "is-open" : ""}`}>
            <div className="modalCustom__container">
                <img src={dataModal.status ? check : error}
                    alt="image"
                    className="modalCustom__container__image"
                />
                <div className="modalCustom__container__message">
                    {dataModal.message}
                </div>
                <button
                    type="button"
                    className="buttonCustom sm"
                    onClick={() => dataModal.status ? navigationNext() : setOpen(false)}>
                    <span>{dataModal.status ? "Ir a simulaciones" : "Cerrar"}</span>
                </button>
                {dataModal.status && (
                    <button
                        type="button"
                        className={`buttonCustom sm  ${loadingClick ? "is-loading" : ""} `}
                        onClick={() => uploadRequest(dataModelQuote)}>
                        <span>Descargar solicitud de cotizacion</span>
                    </button>
                )}
            </div>
        </div>
    );
}

export default ModalGenerateQuote;